export default {
  elementClicked(webElement, actionOutcome, outboundUrl, correlationId) {
    if (typeof window.tagular !== 'undefined') {
      window.tagular('beam', 'ElementClicked', {
        '@type': 'redventures.usertracking.v3.ElementClicked',
        webElement: {
          location: webElement.location,
          position: webElement.position,
          elementType: webElement.elementType,
          text: webElement.text,
          htmlId: webElement.htmlId
        },
        actionOutcome: actionOutcome,
        outboundUrl: outboundUrl,
        correlationId: correlationId
      })
    }
  },
  productClicked(
    productId,
    productName,
    productLocation,
    productRank,
    productVariant,
    clickId,
    productCategory
  ) {
    if (
      !productId ||
      !productName ||
      !productLocation ||
      !productRank ||
      !clickId
    ) {
      throw new Error({
        function: 'tagular_module.product_clicked',
        error: 'Missing a required parameter.'
      })
    }

    if (typeof window.tagular !== 'undefined') {
      window.tagular('beam', 'ProductClicked', {
        '@type': 'redventures.ecommerce.v1.ProductClicked',
        product: {
          productId: productId,
          category: productCategory,
          name: productName,
          location: productLocation,
          position: productRank,
          variant: productVariant
        },
        correlationId: clickId
      })
    }
  }
}
